<template>
    <nav class="navbar navbar-inverse">
      <div class="container-fluid">
        <div class="navbar-header">
          <a class="navbar-brand">
              <img src="/img/logo.png" alt="">
          </a>
          <button type="button" id="navBtn" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#bs-example-navbar-collapse-1" aria-expanded="false">
            <span class="sr-only">Toggle navigation</span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
        </button>
        </div>
        <div class="collapse navbar-collapse" id="bs-example-navbar-collapse-1">
          <ul class="nav navbar-nav navbar-right">
            <li @click="goRouter(item.url)" v-for="(item,index) in list" :key="index"><a>{{item.name}}</a></li>
          </ul>
        </div>
      </div>
    </nav>
</template>

<script>
export default {
    data(){
        return {
            list:[
                {name:"首页",url:"/"},
                {name:"产品展示",url:"/product"},
                {name:"公司简介",url:"/about"},
                {name:"新闻动态",url:"/news"},
                {name:"合作企业",url:"/partner"},
                {name:"联系我们",url:"/contact"},
            ]
        }
    },
    methods:{
        goRouter(url){
            this.$router.push(url);
        }
    }
}
</script>

<style lang="less" scoped>
    .navbar{
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        background-color: rgba(0, 0, 0, 0.4);
        border: 0;
        z-index: 100;
        .navbar-brand{
            padding:0 15px;
            img{
                margin-top: 5px;
                height: 40px;
            }
        }
        .navbar-header a{
            color: #ffffff;
            cursor: pointer;
        }
        .navbar-nav>li>a{
            &:hover{
                color:rgb(247, 6, 13);
            }
            color: #ffffff;
            cursor: pointer;
        }
    }
</style>